import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Paper,
    TableBody,
    Avatar,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded, Download, DownloadDoneOutlined, DownloadOutlined } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";


function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const SubscriptionDetails = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });

    return formattedDate;
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [currentPage, setCurrentPage] = useState(1)
    const [hasEnded, setHasEnded] = useState(false)
    const [limit, setLimit] = useState(20)
    const [subscriptions, setSubscriptions] = useState([])
    const [metrics, setMetrics] = useState({})
    const query = useQuery()

    const FetchSubscriptions = async (page) => {

        if (page == 1) {
            setSubscriptions([])
            setHasEnded(false)
        }
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/get-subscriptions/${query.get("community")}?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSubscriptions(prev => page == 1 ? data.response : [...prev, ...data.response]);
            setCurrentPage(page)

            if (data.response.length < limit) {
                setHasEnded(true)
            }
            // setloading(false);
        } else {
            alert(data.response)
        }

    };

    const FetchSubscriptionMetrics = async () => {


        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/subscription-metrics/${query.get("community")}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setMetrics(data.metrics);
            // setloading(false);
        }

    };

const exportCSV = async () => {
    try {
        const token = localStorage.getItem("token");

        const response = await fetch(
            `${BASE_URL}/community/export-subscriptions/${query.get("community")}`,
            {
                method: "GET",
                headers: {
                    "auth-token": token, // ✅ keep auth header
                },
            }
        );

        if (!response.ok) throw new Error("Failed to download CSV");

        // ✅ get the file as a blob
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // ✅ create temporary link to trigger download
        const link = document.createElement("a");
        link.href = url;
        link.download = `subscriptions_${query.get("community").slice(5)}.csv`; // filename
        document.body.appendChild(link);
        link.click();
        link.remove();

        // cleanup
        window.URL.revokeObjectURL(url);

        console.log("CSV Downloaded ✅");
    } catch (err) {
        console.error("Error downloading CSV:", err);
    }
};


    useEffect(() => {
        FetchSubscriptionMetrics()
        FetchSubscriptions(1);
    }, []);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [communitites, setCommunities] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>

                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>


                    <Typography style={{ fontSize: "25px", fontFamily: "poppins-reg", color: "#f0f0f0", marginBottom: "20px" }} gutterBottom>Subscription Overview</Typography>


                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        pb={"20px"}
                    >
                        <Box
                            display={"grid"}
                            gridColumn={isMobileScreen ? "span 12" : "span 6"}
                            gridTemplateColumns="repeat(12,1fr)"
                            sx={{
                                border: "1.8px solid #ffffff10",
                                borderRadius: "8px",
                            }}
                            paddingY={(isMobileScreen || isTabScreen) ? "5px" : "15px"}>

                            <Box
                                display={'flex'}
                                gridColumn={(isMobileScreen || isTabScreen) ? "span 12" : "span 6"}
                                flexDirection={'column'}
                                px={"35px"}
                                py={(isMobileScreen || isTabScreen) ? "25px" : "10px"}
                                sx={{
                                    borderInlineEnd: `${(isMobileScreen || isTabScreen) ? "0px" : "1.8px"} solid #ffffff10`,
                                    borderBlockEnd: `${(isMobileScreen || isTabScreen) ? "1.8px" : "0px"} solid #ffffff10`
                                }}
                            >

                                <Typography style={{ fontSize: "14px", fontFamily: "poppins-reg", color: "#f0f0f0" }} gutterBottom={false}>Total Active Subscriptions</Typography>
                                <Typography style={{ fontSize: "40px", fontFamily: "poppins-mid" }} gutterBottom={false}>{metrics.totalActiveSubscriptions || 0}</Typography>
                                <Typography style={{ fontSize: "12px", fontFamily: "poppins-reg", color: "#ffffff50" }} gutterBottom={false}>{metrics.newSubscriptionsThisMonth || 0} Subscriptions this month</Typography>

                            </Box>

                            <Box
                                display={'flex'}
                                gridColumn={(isMobileScreen || isTabScreen) ? "span 12" : "span 6"}
                                flexDirection={'column'}
                                px={"35px"}
                                py={(isMobileScreen || isTabScreen) ? "25px" : "10px"}
                            >

                                <Typography style={{ fontSize: "14px", fontFamily: "poppins-reg", color: "#f0f0f0" }} gutterBottom={false}>Total Revenue</Typography>
                                <Typography style={{ fontSize: "40px", fontFamily: "poppins-mid" }} gutterBottom={false}>₹{Number(metrics.totalRevenue || 0).toFixed(2)}</Typography>
                                <Typography style={{ fontSize: "12px", fontFamily: "poppins-reg", color: "#ffffff50" }} gutterBottom={false}>₹{Number(metrics.revenueThisMonth || 0).toFixed(2)} this month</Typography>


                            </Box>


                        </Box>

                        <Box
                            display={"grid"}
                            gridColumn={isMobileScreen ? "span 12" : "span 6"}
                            gridTemplateColumns="repeat(12,1fr)"
                            sx={{
                                border: "1.8px solid #ffffff10",
                                borderRadius: "8px",
                            }}
                            paddingY={(isMobileScreen || isTabScreen) ? "5px" : "15px"}>

                            <Box
                                display={'flex'}
                                gridColumn={(isMobileScreen || isTabScreen) ? "span 12" : "span 6"}
                                flexDirection={'column'}
                                px={"35px"}
                                py={(isMobileScreen || isTabScreen) ? "25px" : "10px"}
                                sx={{
                                    borderInlineEnd: `${(isMobileScreen || isTabScreen) ? "0px" : "1.8px"} solid #ffffff10`,
                                    borderBlockEnd: `${(isMobileScreen || isTabScreen) ? "1.8px" : "0px"} solid #ffffff10`
                                }}
                            >

                                <Typography style={{ fontSize: "14px", fontFamily: "poppins-reg", color: "#f0f0f0" }} gutterBottom={false}>Not Subscribed</Typography>
                                <Typography style={{ fontSize: "40px", fontFamily: "poppins-mid" }} gutterBottom={false}>{metrics.notSubscribed || 0}</Typography>
                                <Typography style={{ fontSize: "12px", fontFamily: "poppins-reg", color: "#ffffff50" }} gutterBottom={false}>members not subscribed yet</Typography>

                            </Box>

                            <Box
                                display={'flex'}
                                gridColumn={(isMobileScreen || isTabScreen) ? "span 12" : "span 6"}
                                flexDirection={'column'}
                                px={"35px"}
                                py={(isMobileScreen || isTabScreen) ? "25px" : "10px"}
                            >

                                <Typography style={{ fontSize: "14px", fontFamily: "poppins-reg", color: "#f0f0f0" }} gutterBottom={false}>Total Cancelled Subscriptions</Typography>
                                <Typography style={{ fontSize: "40px", fontFamily: "poppins-mid" }} gutterBottom={false}>{metrics.totalCancelled || 0}</Typography>
                                <Typography style={{ fontSize: "12px", fontFamily: "poppins-reg", color: "#ffffff50" }} gutterBottom={false}>{metrics.totalCancelled || 0} Cancelled this month</Typography>





                            </Box>


                        </Box>

                    </Box>


                    <Box onClick={() => {
                        exportCSV()
                    }} sx={{
                        flexDirection: 'row', alignItems: 'center', justifyContent: 'center', display: 'flex',
                        background: "#ffffff", borderRadius: "5px", paddingInline: "20px",
                        paddingBlock: "8px", gap: "5px", alignSelf: 'flex-start', marginBottom: "20px", cursor: 'pointer'
                    }}>
                        <DownloadOutlined style={{ color: "#303030", fontSize: "15px" }} />
                        <Typography style={{ fontSize: "12px", fontFamily: "poppins-mid", color: "#303030" }} gutterBottom={false}>Export CSV</Typography>
                    </Box>


                    <TableContainer component={Paper} sx={{ background: "#111", borderRadius: "10px", marginBottom: "20px" }}>
                        <Table>
                            {/* ---------- Table Head ---------- */}
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Profile Photo</TableCell>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Name</TableCell>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Buzz Name</TableCell>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Current Plan</TableCell>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Plan Value</TableCell>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Plan Status</TableCell>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Subscribed on</TableCell>
                                    <TableCell sx={{ color: "#aaa", fontFamily: "poppins-reg" }}>Next Due Date</TableCell>
                                </TableRow>
                            </TableHead>

                            {/* ---------- Table Body ---------- */}
                            <TableBody>
                                {subscriptions.map((community) => (
                                    <TableRow key={community._id} sx={{
                                        "& td": {
                                            borderBottom: "1px solid rgba(105, 105, 105, 0.1)", // <- thin + low opacity
                                        },
                                    }} hover>
                                        {/* Profile Image */}
                                        <TableCell>
                                            <Avatar
                                                src={community.userId?.image?.[0]}
                                                alt={community.userId?.full_name}
                                                sx={{ width: 30, height: 30, border: "2px solid #ffffff10" }}
                                            />
                                        </TableCell>

                                        {/* Full Name */}
                                        <TableCell>
                                            <Typography color="#fff" fontFamily="poppins-reg">
                                                {community.userId?.full_name}
                                            </Typography>
                                        </TableCell>

                                        {/* Buzz Name */}
                                        <TableCell>
                                            <Typography
                                                fontFamily={"poppins-reg"}
                                                sx={{
                                                    color: "#aaa",

                                                    fontSize: "12px",
                                                    display: "inline-block",
                                                }}
                                            >
                                                {community.userId?.buzz_name}
                                            </Typography>
                                        </TableCell>

                                        {/* Community Mail */}
                                        <TableCell sx={{ color: "#fff", fontFamily: "poppins-reg" }}>
                                            {community.subscriptionPlanId.name || "—"}
                                        </TableCell>

                                        <TableCell sx={{ color: "#fff", fontFamily: "poppins-reg" }}>
                                            ₹{community.subscriptionPlanId.fullPlan.pricePerMonth || "—"}/{community.subscriptionPlanId.fullPlan.monthGap == 1 ? "month" : `${community.subscriptionPlanId.fullPlan.monthGap} months`}
                                        </TableCell>

                                        {/* Created Date */}
                                        <TableCell sx={{ fontFamily: "poppins-reg", color: community.status == "active" ? "#00c500ff" : community.status == "cancelled" ? "#ff2200" : community.status == "trial" ? "orange" : "#aaaaaa" }}>
                                            {community.status.toUpperCase()}
                                        </TableCell>

                                        <TableCell sx={{ color: "#fff", fontFamily: "poppins-reg" }}>
                                            {community.createdAt ? new Date(community.startedAt).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                            }) : "—"}
                                        </TableCell>

                                        <TableCell sx={{ color: "#fff", fontFamily: "poppins-reg" }}>
                                            {community.createdAt ? new Date(community.nextBillingDate).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                            }) : "—"}
                                        </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>


                    {
                        !hasEnded && (
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignSelf: 'stretch',
                            }}>
                                <Typography onClick={() => {
                                    FetchSubscriptions(currentPage + 1)
                                }} color={"#ffffff"}
                                    style={{
                                        cursor: 'pointer',
                                        border: "1px solid #ffffff10",
                                        borderRadius: "4px",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                        marginTop: "20px",
                                        marginBottom: "100px",
                                        paddingLeft: "12px",
                                        paddingRight: "12px",
                                        alignSelf: 'center',
                                        alignItems: 'center',
                                        alignContent: 'center',
                                        display: 'flex',
                                        overflowWrap: 'anywhere',
                                    }}
                                    fontFamily={"poppins-reg"}
                                    fontSize={"12px"}>Load More</Typography>
                            </Box>
                        )
                    }


                </Box>

            </Box>
        </>
    );
}

export default SubscriptionDetails;
